







































































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import ReCAPTCHA from '@/components/ReCAPTCHA.vue';
import ReCAPTCHABranding from '@/components/ReCAPTCHABranding.vue';

import * as RouterPath from '@/classification/RouterPath';

import * as StringUtil from '@/common/StringUtil';
import * as Messages from '@/common/Messages';
import * as JwtUtil from '@/common/JwtUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import MailAddressResetParam from '@/models/account/MailAddressResetParam';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      're-captcha-branding': ReCAPTCHABranding,
    },
  },
)
export default class UpdateMail extends BaseView {
  private mailAddress = '';

  private resetParam = new MailAddressResetParam();

  private isEmailMismatch = false;

  private isEmailEmpty = false;

  private isEmailConfirmEmpty = false;

  private isEmailNoChange = false;

  private reCAPTCHA = new ReCAPTCHA();

  private Messages = Messages;

  private AccountRepository = RepositoryFactory.get().account;

  private created() {
    try {
      this.AccountRepository.getAccount().then((response) => {
        this.mailAddress = response.data.email;
      }).catch(() => {
        this.$router.replace(RouterPath.TOP);
      });
    } catch (e) {
      this.$router.replace(RouterPath.TOP);
    }
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * メールアドレス再設定の認証メールを送信します
   */
  private async sendResetMail() {
    if (!this.validate()) return;

    try {
      await this.reCAPTCHA.getToken('reset_email').then((token) => {
        this.resetParam.reCaptchaToken = token;
      }).catch(() => {
        this.$router.replace(RouterPath.TOP);
      });

      await this.AccountRepository.sendMailAddressResetMail(this.resetParam).then((response) => {
        if (response.status === 204) {
          // LocalStorageに現在のログイン情報を保存
          JwtUtil.setLocalJwt();
          this.$router.replace(RouterPath.UPDATE_MAIL_SEND);
        }
      }).catch(() => {
        this.$router.replace(RouterPath.TOP);
      });
    } catch (e) {
      this.$router.replace(RouterPath.TOP);
    }
  }

  /**
   * 入力項目の検証を行います
   */
  private validate() {
    this.isEmailEmpty = false;
    this.isEmailConfirmEmpty = false;
    this.isEmailMismatch = false;
    this.isEmailNoChange = false;

    if (StringUtil.isEmpty(this.resetParam.email)) {
      this.isEmailEmpty = true;
    }

    if (StringUtil.isEmpty(this.resetParam.emailConfirm)) {
      this.isEmailConfirmEmpty = true;
      return false;
    }

    if (this.resetParam.email !== this.resetParam.emailConfirm) {
      this.isEmailMismatch = true;
      return false;
    }

    if (this.mailAddress === this.resetParam.email) {
      this.isEmailNoChange = true;
      return false;
    }
    return true;
  }
}
